import Button from "components/Buttons/Button";
import CarruselHorizontal from "components/Carrusel/CarruselHorizontal";
import Contactanos from "components/Contactanos/Contactanos";
import Header from "components/Header";
// import ScrollTo from "hooks/ScrollTo";
import React from "react";

const Oopt = () => {
  const caracteristicas = [
    {
      icon: "fa-solid fa-chart-line",
      // <i class="fa-solid fa-chart-line"></i>
      description:
        "Ajusta la dificultad en tiempo real según las respuestas del candidato, ofreciendo una precisión superior a los exámenes tradicionales.",
    },
    {
      icon: "fa-solid fa-square-poll-vertical",
      // <i class="fa-solid fa-square-poll-vertical"></i>
      description:
        "Con Brighton Centro de inglés, recibirás tus resultados en 24 horas.",
    },
    {
      icon: "fa-solid fa-computer",
      description:
        "¡Sin instalaciones! Se realiza online desde cualquier dispositivo (casa, escuela u oficina), con corrección automática que ahorra horas de trabajo.",
    },
    {
      icon: "fa-solid fa-circle-info",
      // <i class="fa-solid fa-circle-info"></i>
      description:
        "En los resultados encontrarás tu nivel de inglés según el CEFR (de Pre-A1 a C2), una puntuación sobre 120 y el tiempo empleado.",
    },
  ];
  const steps = [
    {
      num: "1. Regístrate",
      description: "Regístrate y paga tu examen con 1 día de anticipación.",
    },
    {
      num: " 2. Recibe tu link y credenciales.",
      description:
        "Nuestros asesores te enviarán todo por email el dia de tu prueba. Link de presentacion + usuario y contraseña.",
    },
    {
      num: "3. Presenta tu examen",
      description:
        "Presenta tu prueba desde: Casa, oficina, universidad o incluso un café. Solo necesitas conexion a internet por cable y un computador ¡sin descargas!",
    },
    {
      num: "4. Recibe Tus Resultados",
      description:
        "Tu certificado OOPT en 24 hora. Recibe un reporte detallado con nivel CEFR (Pre-A1 a C2), puntuación + análisis por habilidades y tiempo de ejecución.",
    },
  ];
  const CaracteristicasCard = ({ icon, description }) => {
    return (
      <div className="w-1/4 p-10 flex flex-col gap-10 justify-center items-center shadow-[-10px_10px_0px_0px_#0d2334] bg-blue-100 hyphens-none rounded-lg rounded-tl-none text-center">
        <i class={icon} style={{ fontSize: "120px", color: "0d2334" }}></i>
        <p className="text-2xl hyphens-none">{description}</p>
      </div>
    );
  };
  const CardSteps = ({ title, description }) => {
    return (
      <div className="bg-blue-300 p-10 w-[400px] h-[400px] text-primario border-solid border-4 border-primario rounded-lg rounded-tl-none flex flex-col justify-between">
        <h3 className="text-5xl font-bold font-Bebas ">{title}</h3>
        <p className="text-xl hyphens-none">{description}</p>
      </div>
    );
  };
  return (
    <div className=" text-left hyphens-auto">
      <Header
        titulo="Oxford Placement Test"
        classTitulo="text-white"
        info="El Oxford Placement Test (OOPT) es una prueba de versión en computador de selección múltiple y adaptable al nivel de conocimiento en inglés del candidato que realiza la prueba."
        classInfo=""
        linkToSection=""
        botonDescripcion="Conoce el examen"
        classBoton="text-white bg-blue-900"
        img="https://brightonenglishcenter.edu.co/img/portada-oopt.png"
      />
      <section className="bg-primario">
        <div className="flex flex-row justify-center items-start w-3/4 mx-auto py-40 gap-10 text-white">
          <h2 className=" text-7xl font-Bebas tracking-wider text-right w-1/2 text-secundario">
            ¿Buscas una prueba de inglés eficaz, rápida y adaptable?
          </h2>
          <p className="w-1/2 text-3xl hyphens-none">
            El examen
            <strong> Oxford Placement Test (OOPT)</strong> ha posicionado a
            millones de estudiantes en el nivel exacto que necesitan. Ideal para
            jóvenes y adultos, este examen combina tecnología de vanguardia con
            resultados detallados y aprobados por{" "}
            <strong>El Ministerio de Educación</strong>. y adoptado por varias
            instituciones académicas como prueba del nivel de inglés del
            estudiante.{" "}
            <strong>
              ¡Descubre por qué es el favorito de las instituciones en Colombia!
            </strong>
          </p>
        </div>
      </section>
      <section className="">
        <div className="my-40">
          <h2 className="text-7xl text-center font-Bebas font-bold p-5 text-primario tracking-wider">
            ¿Qué hace único al OOPT?
          </h2>
        </div>
        <CarruselHorizontal outputA="40%" outputB="-50%">
          {caracteristicas.map((value, index) => (
            <CaracteristicasCard
              key={index}
              icon={value.icon}
              description={value.description}
            />
          ))}
        </CarruselHorizontal>
        <div className="w-3/4 mx-auto space-y-10">
          <h2 className="w-full text-center text-6xl font-Bebas tracking-wider font-bold ">
            ¿Que evalua el examen oopt?
          </h2>
          <div className="w-full flex flex-row justify-center gap-10">
            <div className="flex flex-col gap-5 shadow-[-10px_10px_0px_0px_#0d2334] bg-white text-primario rounded-lg rounded-tl-none overflow-hidden w-1/3 p-10">
              <h3 className="text-5xl font-bold font-Bebas tracking-wide">
                Use of english
              </h3>
              <p className=" text-2xl hyphens-none">
                Enfocado a formas gramaticales y los significados que estas
                formas contienen (ej. significado de palabras, frases y
                oraciones).
              </p>
            </div>
            <div className="flex flex-col gap-5 shadow-[-10px_10px_0px_0px_#0d2334] bg-white text-primario rounded-lg rounded-tl-none overflow-hidden w-1/3 p-10">
              <h3 className="text-5xl font-bold font-Bebas tracking-wide">
                Listening
              </h3>
              <p className=" text-2xl hyphens-none">
                Evalúa la capacidad de identificar el significado literal,
                intencionado e implícito de la muestra que están escuchando.
              </p>
            </div>
          </div>
        </div>
        <div className="w-full bg-primario">
          
          <div className="my-20 p-40 flex flex-row justify-center items-start gap-10 ">
            <h2 className="text-7xl font-Bebas font-bold text-secundario w-1/3 text-right tracking-wider">
              ¿Cómo funciona?
            </h2>
            <div className="w-1/3 flex flex-col gap-10 items-start text-2xl bgblu2 text-white hyphens-none">
              <p className="">
                El examen <strong>Oxford Placement Test (OOPT)</strong> detecta
                fortalezas y debilidades segundo a segundo, adaptando la
                dificultad de las preguntas según cada respuesta.{" "}
                <em>¡No es magia, es tecnología adaptativa de vanguardia!</em>
              </p>
              <p>¿Listo para certificar tu nivel de inglés?</p>
              <a href="http://" className="self-end">
                <Button
                  text="Comienza Aquí"
                  bgColor="#15596c"
                  color="#ffff86"
                />
              </a>
            </div>
          </div>
          <div className="w-full h-[85vh] rounded-30 rounded-tl-none">
            <img
              src="https://brightonenglishcenter.edu.co/img/WEB17.webp"
              alt="Oxford Placement Test (OOPT)"
              className="w-full object-cover h-full object-top"
            />
          </div>
        </div>
      </section>
      {/* section: Passos para el registro */}
      <section className="">
        <div className="w-3/4 mx-auto my-40 flex flex-row gap-10 justify-center items-start">
          <div className="w-1/3 space-y-4 relative">
            {steps.map((value, index) => (
              <div
                key={index}
                className={` sticky w-max top-1/4`}
                style={{
                  // left: `${i * 30}px`,
                  transform: `translateY(${index * 15}px) translateX(${
                    index * 15
                  }px)`,
                  zIndex: index + 1,
                }}
              >
                <CardSteps
                  key={index}
                  title={value.num}
                  description={value.description}
                />
              </div>
            ))}
          </div>
          <div className="w-1/3 sticky top-1/3 h-full flex flex-col gap-10 items-start">
            <h2 className="font-Bebas text-7xl text-primario tracking-wide font-bold">
              Prepara tu prueba OOPT con Brighton
            </h2>
            <p className="hyphens-none text-2xl bgblue300">
              No dejes pasar esta oportunidad de avanzar en tu aprendizaje del
              inglés. ¡Únete a nosotros y descubre cómo el{" "}
              <strong>Oxford Online Placement Test</strong> puede abrir nuevas
              puertas en tu desarrollo lingüístico!
            </p>
            <a
              href="https://forms.gle/KyNQFjCv1nypCRX79"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Formulario de registro para el examen OOPT"
            >
              <Button
                text="Iniciar Mi Registro"
                bgColor="#93c5fd"
                color="#0d2334"
              />
            </a>
          </div>
        </div>
      </section>
      <Contactanos
        titulo="¡4 pasos, 24 horas y un futuro en inglés te esperan!"
        classTitulo="text-primario"
        texto="No dejes pasar esta oportunidad de avanzar en tu aprendizaje del
          inglés. ¡Únete a nosotros y descubre cómo el Oxford Online Placement
          Test puede abrir nuevas puertas en tu desarrollo lingüístico!"
        boton="Reservar Mi OOPT AHORA"
        classBoton="bg-blue-900 text-white hover:bg-blue-800"
        link="https://forms.gle/KyNQFjCv1nypCRX79"
        img="https://brightonenglishcenter.edu.co/img/oopt.webp"
      />
    </div>
  );
};

export default Oopt;
